import './style/sample.css';
import { initializeApp } from './js/app.js';

// Initialize the app
console.log('Webpack Initiated!');

document.addEventListener('DOMContentLoaded', () => {
  initializeApp();
});
